// Dependencies
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'

// Internal deps
import Store from './store'
import Routes from './routes'
import RoutesSV from './routes.sv'

// Filters
import Translate from './filters/translate'
import FormatNumber from './filters/number'
import FormatDate from './filters/date'
import FormatCurrency from './filters/currency'
import UTF8 from './filters/utf8'
import Base64 from './filters/base64'
import ISO3166 from './filters/iso3166'

Vue.filter('translate', Translate.translate)
Vue.filter('formatNumber', FormatNumber.format)
Vue.filter('formatDate', FormatDate.formatDate)
Vue.filter('formatTime', FormatDate.formatTime)
Vue.filter('formatDateTime', FormatDate.formatDateTime)
Vue.filter('formatCurrency', FormatCurrency.format)
Vue.filter('utf8CodePoints', UTF8.codePoints)
Vue.filter('b64Encode', Base64.encode)
Vue.filter('b64Decode', Base64.decode)
Vue.filter('isoCountryToLanguage', ISO3166.countryToLanguage)
Vue.filter('isoLanguageToCountry', ISO3166.languageToCountry)

const hostname = window.location.hostname.toLowerCase()
const [ topDomain ] = hostname.match(/(localhost|\.\w{2,4}$)/gm)

Vue.use(VueResource)
// Set up routes
let router = new VueRouter({
  mode: 'history',
  routes: ['localhost', '.se'].indexOf(topDomain) > -1 ? RoutesSV : Routes,
  scrollBehavior (to, from, savedPosition) {
    // prevent scrolling on the posters page
    if (['artist', 'posters'].indexOf(to.name.toLowerCase()) < 0 || ['artist', 'posters'].indexOf(from.name.toLowerCase()) < 0) {
      return { x: 0, y: 0 }
    }
  }
})

Vue.use(VueRouter)

// Include Tag Manager in production.
if (process.env.ALLOW_TRACKING) {
  /* eslint-disable */
  /*
   * Google Tag Manager.
   */
  let gtmFunc = (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
  });

  // Ensure dataLayer exists.
  window.dataLayer = typeof dataLayer !== 'undefined' ? dataLayer : []

  // Globally register tracking function.
  window.gtm = gtmFunc

  /*
   * Initialize all the trackers and track the page load. Always last in section.
   */
  Store.dispatch('initializeTracking')

  // Re-enable ESLint for everything after this section.
  /* eslint-enable */
}

if (['.se'].indexOf(topDomain) > -1) {
  // Store.dispatch('clearCheckoutSoft', true)
  const currencyByTopDomain = Store.getters.currencyByTopDomain
  Store.dispatch('setCurrency', currencyByTopDomain['.se'])
}

function findProperty (obj, name) {
  const prop1 = (name + '').toLowerCase()
  for (var prop2 in obj) {
    if (obj.hasOwnProperty(prop2) && prop1 === (prop2 + '').toLowerCase()) {
      return prop2
    }
  }
  return null
}

// Implement error pages and update titles on page switch.
router.beforeEach(function (to, from, next) {
  // If we're accessing index, forward to the English start page.

  // Set default currency for top domain (if not set yet).
  if (Store.getters.currencyIsSet) {
    const currencyByTopDomain = Store.getters.currencyByTopDomain
    Store.dispatch('setCurrency', currencyByTopDomain[topDomain])
  }

  switch (topDomain) {
    case '.se':
    case 'localhost':
      Store.dispatch('setLanguage', 'sv')
      break
    default:
      Store.dispatch('setLanguage', 'en')
      break
  }

  // Update page title.
  //
  // Note: Since the store is updated after the route, we won't be able to set the poster until after the title has been
  // updated, which means that it will always be the previously viewed poster shown in the title, if we handle this
  // route in main.js. Therefore, the poster route is specially handled in the pages/poster/script.js.
  let title = 'Born This Day'
  if (to.meta.title) {
    // The start page will have the tag line first.
    if (to.name === 'index') {
      title = 'Born This Day | ' + Translate.translate(to.meta.title)
    } else {
      title = Translate.translate(to.meta.title)
      if (to.meta.punchLine) {
        title += ' | ' + Translate.translate(to.meta.punchLine)
      }
      title += ' | Born This Day'
    }
  }
  document.title = title

  // If we're heading to an error page, make sure we decide on an error language to show.
  // let errLang = Store.getters.getCurrLanguage.iso

  try {
    Store.dispatch('trackPageLoad', to.path) // We'll track any page from here on, even if it doesn't exist.
  } catch (e) {
    console.log(e.message)
  }

  // If we've changed the language in the route, implement it here.
  //
  // Note: if we go to "/posters", that's considered the language. Make sure we have an ISO2 code.
  /* switch (true) {
    // No language, and not the error page.
    case !to.params:
    case !/^[a-z]{2}$/i.test(to.params.country):
      next('/' + errLang + '/error/404')
      return
    // Valid country param, but a new language. Set it before we continue.
    default:
      if (Store.getters.getCurrLanguage.iso !== to.params.country) {
        errLang = to.params.country

        Store.dispatch('setLanguage', to.params.country)

        break
      }
  } */

  // Route doesn't exist?
  /* if (to.matched.length < 1) {
    next('/' + errLang + '/error/404')
    return
  } */

  const medium = findProperty(to.query, 'medium')
  const name = findProperty(to.query, 'name')
  const voucher = findProperty(to.query, 'voucher')
  const validTo = findProperty(to.query, 'validTo')
  const showNotice = findProperty(to.query, 'showNotice')
  if (to.query && medium !== null && name !== null && voucher !== null && validTo !== null) {
    Store.dispatch('addVoucher', to.query[voucher]).catch(function () { })
    try {
      if (showNotice !== null && to.query[showNotice] === 'true') {
        const cookieValue = JSON.stringify({
          medium: to.query[medium],
          name: to.query[name],
          voucher: to.query[voucher],
          validto: to.query[validTo]
        })
        const expires = new Date(to.query[validTo])
        if (expires instanceof Date && !isNaN(expires)) {
          document.cookie = 'notice=' + cookieValue + ';path=/;expires=' + expires.toGMTString()
        } else {
          document.cookie = 'notice=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
        }
      } else {
        document.cookie = 'notice=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
      }
      delete to.query[medium]
      delete to.query[name]
      delete to.query[voucher]
      delete to.query[validTo]
      delete to.query[showNotice]
      router.replace({ name: to.name, query: to.query })
    } catch (err) {
      console.log(err)
    }
  }

  // Route doesn't exist?
  if (to.matched.length < 1) {
    next('/error/404')
    return
  }

  // Normal flow.
  next()
})

/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  template: '<router-view />',
  router,
  store: Store
})



// WEBPACK FOOTER //
// ./src/main.js